import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { CategoryComponent } from "./category/category.component";
import { StationComponent } from "./station/station.component";
import { PageComponent } from "./page/page.component";

const appRoutes: Routes = [
  {
    path: "home",
    component: HomeComponent
    // canActivate: [AuthGuard]
  },
  {
    path: "categories",
    component: CategoryComponent
    // canActivate: [AuthGuard]
  },
  {
    path: "category/:slug",
    component: CategoryComponent
    // canActivate: [AuthGuard]
  },
  {
    path: "station/:slug",
    component: StationComponent
    // canActivate: [AuthGuard]
  },
  {
    path: "page/:slug",
    component: PageComponent
    // canActivate: [AuthGuard]
  },
  {
    path: "**",
    component: HomeComponent
    // redirectTo: "/"
  }
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: false });
